module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel4-a86b4d9ee59b24ee630c5ea3e7cbadb7.jpg";